import type { HelpFile } from '../../types/help'
import { RestrictionRuleViolationsTestIds } from '../../../testids/RestrictionRuleViolationsTestIds'

export const restrictionRuleViolationsHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleViolationsTestIds.restrictionRuleViolations]:
      'Violations recorded for this restriction rule — identities holding denied access profiles in conflict with the rule condition.',
    [RestrictionRuleViolationsTestIds.emptyStateViolations]:
      'No violations recorded for this rule — run violation detection to check for current violations.',
    [RestrictionRuleViolationsTestIds.colDetectedAt]:
      'When the violation was first detected.',
    [RestrictionRuleViolationsTestIds.colIdentity]:
      'Identity that violates this restriction rule.',
    [RestrictionRuleViolationsTestIds.colResolvedAt]:
      'When the violation was resolved — access removed or rule changed; empty if still open.',
    [RestrictionRuleViolationsTestIds.colViolatingProfile]:
      'Denied access profile held by the violating identity.',
  },
}
